/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOut } from './CarveOut';
import {
    CarveOutFromJSON,
    CarveOutFromJSONTyped,
    CarveOutToJSON,
} from './CarveOut';

/**
 * 
 * @export
 * @interface CreateCarveOut201Response
 */
export interface CreateCarveOut201Response {
    /**
     * 
     * @type {CarveOut}
     * @memberof CreateCarveOut201Response
     */
    data?: CarveOut;
}

/**
 * Check if a given object implements the CreateCarveOut201Response interface.
 */
export function instanceOfCreateCarveOut201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateCarveOut201ResponseFromJSON(json: any): CreateCarveOut201Response {
    return CreateCarveOut201ResponseFromJSONTyped(json, false);
}

export function CreateCarveOut201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCarveOut201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CarveOutFromJSON(json['data']),
    };
}

export function CreateCarveOut201ResponseToJSON(value?: CreateCarveOut201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CarveOutToJSON(value.data),
    };
}

